// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mg-2";
export var interactiveWrapper = "_mg-0";
export var shippingHoverPreview = "_mg-4";
export var summaryBadgeTrigger = "_mg-1";
export var widgetHoverPreviewList = "_mg-3";
export var widgetPreviewScale = "_mg-5";